<template>
  <div>
    <el-form :model="formData" inline>
        <el-form-item>
            <CustomInput label="模块">
                <ESelect
                    style="width:140px"
                    v-model="formData.mode"
                    clearable
                    placeholder="全部"
                    @change="()=>initList()"
                >
                    <el-option
                        v-if="modeList.length"
                        label="全部"
                        value=""
                    />
                    <el-option
                        v-for="item in modeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </ESelect>
            </CustomInput>
        </el-form-item>
        <el-form-item>
            <CustomInput label="处理ID">
                <ESelect
                    style="width:140px"
                    v-model="formData.ids"
                    multiple
                    filterable
                    collapse-tags
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="handleRemoteIdMethod"
                    placeholder="请输入ID搜索"
                    ref="idRef"
                    @remove-tag="()=>initList()"
                    @clear="()=>initList()"
                    @visible-change="handleVisibleChange"
                >
                    <p class="option-select">
                        <el-button type="text" @click="handleIdCheckAll">全选</el-button>
                        <el-button type="text" @click="()=>formData.ids=[]">取消全选</el-button>
                    </p>
                    <el-option
                        v-for="item in idList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </ESelect>
            </CustomInput>
        </el-form-item>
         <el-form-item>
            <CustomInput label="处理状态">
                <ESelect
                    style="width:140px"
                    v-model="formData.status"
                    clearable
                    placeholder="全部"
                    @change="()=>initList()"
                >
                    <el-option
                        v-if="statusList.length"
                        label="全部"
                        value=""
                    />
                    <el-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </ESelect>
            </CustomInput>
        </el-form-item>
        <el-form-item>
            <CustomInput label="处理详情" @append-click="()=>initList()">
                <el-input style="width:140px" v-model="formData.keyword" @keydown.enter="()=>initList()" clearable placeholder="请输入关键词查询"/>
                <template #append><i class="el-icon-search"/></template>
            </CustomInput>
        </el-form-item>
        <el-form-item>
            <CustomInput
                label="提交时间"
            >
                <el-date-picker
                    style="width:240px"
                    v-model="formData.date"
                    type="daterange"
                    @change="()=>initList()"
                    range-separator="至"
                    :clearable="false"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    :picker-options="pickerOptions"
                    end-placeholder="结束日期"/>
            </CustomInput>
        </el-form-item>
    </el-form>
    <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        stripe
        :header-cell-style="{background:'#e8eaec',color:'#333'}"
        max-height="400px"
        size="mini"
    >
        <el-table-column label="ID" width="80" prop="id"/>
        <el-table-column label="模块" width="120" prop="module_name"/>
        <el-table-column  width="120" prop="status_text">
            <template #header>
                <div class="header-status">
                    <span>处理状态</span>
                    <div class="progress-box" v-show="timer !==0">
                        <el-progress type="circle" :width='20' :stroke-width="2" :format="()=>timer" :percentage="100-(((timer || 1)-1) *20)"></el-progress>
                    </div>
                </div>
            </template>
            <template slot-scope="{ row }">
                <span
                    :class="{
                        queue: row.status === STATUS_TYPES.QUEUE,
                        progress: row.status === STATUS_TYPES.PROGRESS,
                        success: row.status === STATUS_TYPES.SUCCESS,
                        all_fail: row.status === STATUS_TYPES.All_FAIL,
                        some_fail: row.status === STATUS_TYPES.SOME_FAIL,
                    }"
                >
                    {{row.status_text}}
                </span>
                <template v-if="[ STATUS_TYPES.All_FAIL, STATUS_TYPES.SOME_FAIL ].includes(row.status)">
                    <el-tooltip  effect="dark"  placement="top">
                        <div slot="content" >
                            <p v-if="row.retry_id">
                                已重试，新任务ID【{{row.retry_id}}】
                            </p>
                            <div v-html="row.error_msg" style="max-height: 400px;overflow: auto;"/>
                        </div>
                        <i class="el-icon-warning some_fail all_fail"/>
                    </el-tooltip>
                </template>
            </template>
        </el-table-column>
        <el-table-column label="处理详情" prop="detail"/>
        <el-table-column label="提交时间" width="150" prop="export_time"/>
        <el-table-column label="操作" width="120">
            <template slot-scope="{ row }">
                <el-button
                    type="text"
                    :disabled="![STATUS_TYPES.SUCCESS, STATUS_TYPES.SOME_FAIL].includes(row.status)"
                    v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '处理队列(查看)' }"
                    @click="handleSeeDetail(row)"
                >
                    查看
                </el-button>
                 <el-button
                    v-if="is_admin"
                    type="text"
                    :disabled="![STATUS_TYPES.All_FAIL, STATUS_TYPES.SOME_FAIL].includes(row.status) || row.retry_status===0"
                    v-matomo="{behaviorCategory: '系统功能', event: '点击',  name: '处理队列(重试)' }"
                    @click="()=>handleRetry(row)"
                    :loading="row.isRetry"
                >
                    重试
                </el-button>
            </template>
        </el-table-column>
    </el-table>
     <el-pagination
        class="tac mt20"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[ 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import router from '@/router'
import CustomInput from '@/components/CustomInput'
import { getTreatmentQueueApi, getTreatmentRetryApi, getBaseModulesApi , updateTreatmentQueueApi, getTreatmentIdsApi } from '@/api';
import { Select } from '@/views/mixins/ele'
const STATUS_TYPES = {
    QUEUE: '1',
    PROGRESS: '2',
    SUCCESS: '3',
    All_FAIL: '4',
    SOME_FAIL: '5'
};
const MODULE_TYPES = {
    MATERIAL: '11',
    WORK_ORDER: '10'
};

export default {
    name: 'WorkOrderQueueModal',
    components: {
        CustomInput
    },
    props: ['is_admin', 'ids' ],
    mixins: [ Select({ ref: 'idRef', list: 'idList' }) ],
    data() {
        const _ids = (""+(this.ids || '')).split(',').filter(Boolean);
        return {
            STATUS_TYPES,
            formData: {
                mode: '',
                status: '',
                keyword: '',
                date: [],
                ids: _ids
            },
            modeList: [],
            statusList: [
                { value: STATUS_TYPES.QUEUE, label: '排队中' },
                { value: STATUS_TYPES.PROGRESS, label: '处理中' },
                { value: STATUS_TYPES.SUCCESS, label: '处理成功' },
                { value: STATUS_TYPES.All_FAIL, label: '全部处理失败' },
                { value: STATUS_TYPES.SOME_FAIL, label: '部分处理失败' },
            ],
            tableData: [],
            loading: false,
            pageNum: 1,
            pageSize: 30,
            total: 0,
            updateIds: [],
            lock: false,
            timer: 0,
            idList: [],//处理id
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now();
                },
            },
        }
    },
    created() {
        this.latest7Days()
        this.getBaseModules()
        this.getList()
    },
    beforeDestroy() {
        this.updateIds = [];
    },
    methods: {
        handleVisibleChange(viseble) {
            if (!viseble) {
                this.initList()
            }
        },
        handleIdCheckAll() {
            const ids = this.formData.ids;
            const idList = this.idList.filter(v=> !ids.includes(v.value)).map(v=>v.value);
            this.formData.ids = [...ids,...idList];
        },
        async handleRemoteIdMethod(search) {
            try {
                const { data } = await getTreatmentIdsApi({
                    search_type: 'id',
                    search
                });
                this.idList = data.list.map(v=> {
                    return {
                        value: v.id,
                        lebel: v.id,
                    }
                })
            } catch (error) {
                console.log(error, '获取id列表失败');
            }
        },
        latest7Days () {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let day = date.getDate();
            let endDate = year+'-'+month+'-'+day;
            let lastMonthDay = new Date(date.getTime()-1000*60*60*24*7);
            let startDate = lastMonthDay.getFullYear()+'-'+(lastMonthDay.getMonth()+1)+'-'+lastMonthDay.getDate();
            this.formData.date = [startDate,endDate];
        },
        // 重试
        async handleRetry(row) {
            try {
                const params = {
                    id: row.id
                };
                row.isRetry = true;
                await getTreatmentRetryApi(params);
                this.$message.success('重试成功')
                this.initList()
            } catch (error) {
                console.log(error, '重试失败');
                this.$message.error(error.info)
            }finally {
                row.isRetry = false
            }

        },
        // 初始化分页
        initList() {
            this.pageNum = 1;
            this.getList()
        },
        // 列表
        async getList() {
            try {
                const { mode, status, keyword, date, ids } = this.formData;
                const params = {
                    module_id: mode,
                    status: status,
                    range_time: date&&date.length?date.join('/') : '',
                    id: ids,
                    search: keyword,
                    pn: this.pageNum,
                    rn: this.pageSize
                };
                this.loading = true
                const { data } = await getTreatmentQueueApi(params);
                const changeIds = [];
                this.tableData = data.list.map(v=> {
                    if ([  STATUS_TYPES.PROGRESS, STATUS_TYPES.QUEUE ].includes(v.status)) {
                        changeIds.push(v.id)
                    }
                    return {
                        ...v,
                        isRetry: false,//重试
                    }
                });
                this.total = data.totalCnt;
                this.updateIds = changeIds;
            } catch (error) {
                console.log(error, '处理队列发生错误');
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        },
        updateListStatus() {
            if (this.lock || !this.updateIds.length) {
                return
            };
            this.timer = 5
            this.lock = true;
            let time = null;
            time = setInterval(()=> {
                if ( this.timer<=0) {
                    clearInterval(time);
                    this._updateListStatus()
                }else {
                    --this.timer
                };
            }, 1000)
        },
        async _updateListStatus() {
            try {
                if (!this.updateIds.length) {
                    return;
                }
                const params = {
                    ids: [...this.updateIds].toString()
                }
                const { data } = await updateTreatmentQueueApi(params);
                const changeIds = [];
                const keyData = data.filter(v=> {
                    const isFilter = [  STATUS_TYPES.PROGRESS, STATUS_TYPES.QUEUE ].includes(v.status)
                    if (!isFilter) {
                        changeIds.push(v.id)
                    };
                    return !isFilter;
                }).reduce((pre, item)=> {
                    pre[item.id] = item;
                    return pre;
                }, {});
                this.updateIds = this.updateIds.filter(v=>!changeIds.includes(v));
                if (Object.keys(keyData).length>0) {
                    this.tableData = this.tableData.map(v=> {
                        if (keyData[v.id]) {
                            return {
                                ...v,
                                ...keyData[v.id],
                            }
                        }else {
                            return v;
                        }
                    })
                }

            } catch (error) {
                console.log(error,'更新发生错误');
                this.$message.error(error.info)
            }finally {
                Promise.resolve().then(()=> {
                    this.lock = false
                    if (this.updateIds) {
                        this.updateListStatus()
                    }
                })
            }
        },
        // 模块
        async getBaseModules() {
            const { data } = await getBaseModulesApi();
            this.modeList = data.map(v=> {
                return {
                    ...v,
                    value: v.id,
                    label: v.module_name
                }
            })

        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.initList()
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getList()
        },
        handleSeeDetail({ module_id, object_id }) {
            if (MODULE_TYPES.MATERIAL === module_id) {
                const route = router.resolve({
                    path: '/work_order/store',
                    query: {
                        md5: (object_id || '').toString()
                    }
                });
                window.open(route.href, '_blank')
            }else if(MODULE_TYPES.WORK_ORDER === module_id) {
                const route = router.resolve({
                    path: '/work_order/work_order_material',
                    query: {
                        topage: 'TaskInfoPage',
                        fromPage: 'TaskPage',
                        id: object_id
                    }
                });
                window.open(route.href, '_blank')
            }
        }
    },
    watch: {
        updateIds() {
            this.updateListStatus()
        }
    }

}
</script>

<style lang="scss" scoped>
.header-status {
    position: relative;

}
.progress-box {
    position: absolute;
    right: 10px;
    top: 0;
    &::v-deep  {
        .el-progress__text {
            font-size: 12px !important;
        }
    }
}
.progress {
    color: #409EFF;
}
.success {
    color: #67C23A;
}
.all_fail,.some_fail {
    color: #F56C6C;
}
</style>
